import { all, fork } from "redux-saga/effects";

import getGroupWatcher from "./appSagas/groups/get";



export default function* rootSagas(): Generator {
  yield all([
    fork(getGroupWatcher),
  ]);
}
